import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import Seo from "../components/Seo";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  // Already signed in as admin? Skip straight to the dashboard.
  useEffect(() => {
    if (user?.role === "admin") navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.email, form.password);
      if (u.role !== "admin") {
        toast.error("This portal is for staff only.");
        return;
      }
      toast.success(`Welcome back${u.name ? `, ${u.name.split(" ")[0]}` : ""}.`);
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="max-w-md mx-auto px-6 py-24">
      <Seo title="Staff sign in" path="/admin/login" noIndex />
      <div className="label-eyebrow mb-3">Staff portal</div>
      <h1 className="font-serif-display text-4xl md:text-5xl leading-none mb-3">Sign in.</h1>
      <p className="text-sm opacity-60 mb-10">
        Kaiya staff only. Customers do not need an account to shop.
      </p>
      <form onSubmit={submit} className="space-y-4">
        <input
          data-testid="admin-email"
          required
          type="email"
          placeholder="Email"
          className="kaiya-input"
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
        />
        <input
          data-testid="admin-password"
          required
          type="password"
          placeholder="Password"
          className="kaiya-input"
          value={form.password}
          onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
        />
        <button
          data-testid="admin-submit"
          disabled={loading}
          type="submit"
          className="btn-primary w-full inline-flex items-center justify-center gap-2 disabled:opacity-50"
        >
          {loading && <Loader2 size={16} className="animate-spin" />}
          Sign in
        </button>
      </form>
      <div className="mt-12 text-center text-xs opacity-50">
        <Link to="/">← Back to home</Link>
      </div>
    </div>
  );
}
